module.exports = __webpack_public_path__ + "static/media/container2.371141a2.jpg";